<compartido-ficha [configuracion]="configFicha">
  <compartido-formulario
    [configuracion]="configFormulario"
    (valores)="valorFormulario = $event; cargarDatos$()"
  ></compartido-formulario>

  <ng-container *ngIf="cargando">
    <mat-spinner class="carga" [diameter]="70"></mat-spinner>
  </ng-container>

  <ng-container *ngIf="!cargando && datos === undefined">
    <div class="sin-datos borde">
      <mat-icon>info</mat-icon>
      <h3>Por favor seleccione una organización</h3>
    </div>
  </ng-container>

  <ng-container *ngIf="!cargando && datos !== undefined">
    <div class="tareas">
      <div class="tarea borde" *ngFor="let tarea of tareas">
        <div class="cont-icono">
          <mat-icon class="icono" [class.verde]="!esHoy" inline>
            {{ tarea.icono }}
          </mat-icon>
        </div>
        <h2>{{ tarea.nombre }}</h2>
        <p class="descripcion">{{ tarea.descripcion }}</p>
        <div class="estadisticas">
          <h4 *ngFor="let estadistica of tarea.estadisticas">
            <span
              *ngIf="esHoy || !estadistica.ocultarPasado"
              class="numero color-{{ estadistica.color }}"
            >
              {{ datos[tarea.slug][estadistica.slug] }}
            </span>
            <span
              *ngIf="!esHoy && estadistica.ocultarPasado"
              class="numero color-{{ estadistica.color }}"
              matTooltip="Solo aplica para la fecha actual"
            >
              -
            </span>
            <span>{{ estadistica.nombre }}</span>
          </h4>
        </div>
        <div
          [matTooltip]="
            !esHoy && !tarea.botonPasado
              ? 'Solo aplica para la fecha actual'
              : ''
          "
        >
          <button
            [disabled]="!esHoy && !tarea.botonPasado"
            mat-flat-button
            class="boton-realizar"
            color="primary"
            (click)="realizarTarea(tarea.slug)"
          >
            Realizar Tarea
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</compartido-ficha>
